const state = {

}

const mutations = {

}

export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/panoramicData.js